import { Container } from "./Containers";
import { Headset } from "./Device";
import { Log } from "./Log";

export enum MATCH_STATUS {
  STANDBY = "PENDIENTE",
  READY = "LISTO",
  IN_PROGRESS = "EN PROGRESO",
  COMPLETE = "COMPLETA",
}

export type Match = {
  _id: string;
  score: string;
  endDate: string;
  container: Container[];
  containerId: string;
  headset: Headset[];
  headsetId: string;
  logs: Log[];
  playerAlias: string;
  status: keyof typeof MATCH_STATUS;
  userId: string;
};
